module.exports = __webpack_public_path__ + "static/media/Apple SDGothicNeoR00-01.ac5fe59a.svg";